/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Row, Col, Button, ButtonGroup, ButtonToolbar } from 'reactstrap'

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import KeywordGroupModal from './KeywordGroupModal.js'
import KeywordsInAGroup from './KeywordsInAGroup.js'

import ConfirmationModal from '../widgets/ConfirmationModal'

import {AppContext} from '../AppContext';

class KeywordGroups extends React.Component
{
  tabActive = false;

  constructor(props)
  {
    super();

    this.state =
    {
      keywordGroups: [],
      selected: null,
      modalAction: null,
      modalIsOpen: false,
      objectTypes: [],
      confirmationModalIsOpen: false,
      modalText: undefined,
      selectedObjectTypes: [],
      keywordValueTypes: []
    }

    this.newButtonHandler = this.newButtonHandler.bind(this);
    this.editButtonHandler = this.editButtonHandler.bind(this);
    this.deleteButtonHandler = this.deleteButtonHandler.bind(this);
    this.refreshButtonHandler = this.refreshButtonHandler.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.deleteKeywordGroup = this.deleteKeywordGroup.bind(this);
    this.setSelectedObjectTypes = this.setSelectedObjectTypes.bind(this);
    this.fetchKeywordGroups = this.fetchKeywordGroups.bind(this);
  }

  closeModal(event)
  {
    this.setState({modalIsOpen: false, modalAction: null});
  }

  componentDidMount()
  {
    document.title = this.context.websiteProfile.profileName + ': Keyword Groups'
    this.fetchKeywordGroups();
    this.fetchObjectTypes();
    this.fetchKeywordValueTypes();
    if (this.props.activeTab === this.props.tabIndex) this.tabActive = true;
  }

  componentDidUpdate()
  {

     if (this.props.activeTab === this.props.tabIndex)
     {
        if (!this.tabActive)
        {
          this.fetchKeywordGroups();
          this.fetchObjectTypes();
          this.fetchKeywordValueTypes();
          this.tabActive = true;
        }
     } 
     else
     {
        this.tabActive = false;
     }
  }

  deleteButtonHandler()
  {
    if (null === this.state.selected)
    {
      this.context.postNotification('info', 'Select a keyword group first.');
      return;
    } 

    this.setState(
    {
      confirmationModalIsOpen: true,
      modalText: 'Are you sure you want to remove this keyword group.  Remember, if you proceeed, some of your objects may transition back to the upload tab.'
    });
  }

  async deleteKeywordGroup(confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;

    var bodyData = {};
    bodyData.keywordGroupId = this.state.keywordGroups[this.state.selected].keywordGroupId

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'deleteKeywordGroup', bodyData);
    if ('success' !== result.status)
    {
      this.setState({createSaveDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Unable to delete a keyword group');
    } 
    this.context.postNotification('info', 'Keyword group deleted.');
    
    let keywordGroups = this.state.keywordGroups;
    keywordGroups.splice(this.state.selected, 1);
    this.setState({keywordGroups: keywordGroups, selected: null});
  }

  editButtonHandler()
  {
    if (null === this.state.selected)
    {
      this.context.postNotification('info', 'Select a keyword group first.');
      return;
    } 

    this.fetchObjectTypeRestrictions(this.state.keywordGroups[this.state.selected].keywordGroupId);
    this.setState({modalIsOpen: true, modalAction: 'update'});
  }

  async fetchKeywordGroups(keywordGroupToSelect)
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getKeywordGroups');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting keyword groups');

    let selectedRow = this.state.selected;
    if (undefined !== keywordGroupToSelect)
    {
      for (let x = 0; x < result.jsonData.keywordGroups.length; x++)
      {
        if (keywordGroupToSelect === result.jsonData.keywordGroups[x].keywordGroup)
        {
          selectedRow = x;
          break;
        }
      }
    }
 
    this.setState(
    {
      keywordGroups: result.jsonData.keywordGroups, 
      selected: selectedRow,
      modalAction: null
    });
  }

  async fetchKeywordValueTypes()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getKeywordValueTypes');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting keyword value types');
    let keywordValueTypes = []
    for (let x = 0; x < result.jsonData.keywordValueTypes.length; x++)
      keywordValueTypes[x] = {label: result.jsonData.keywordValueTypes[x].keywordValueType, value: result.jsonData.keywordValueTypes[x].keywordValueType};

    this.setState({keywordValueTypes: keywordValueTypes});
  }

  async fetchObjectTypes()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getEnabledObjectTypes');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting enabled object types');
    this.setState({objectTypes: result.jsonData.enabledObjectTypes});
  }

  async fetchObjectTypeRestrictions(keywordGroupId)
  {
    let bodyData = {keywordGroupId: keywordGroupId};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getObjectTypeRestrictions', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting object type restrictions');

    if (null !== result.jsonData.objectTypeRestrictions)
    {
      let y = result.jsonData.objectTypeRestrictions.length;
      let selectedObjectTypes = [];
      let x = 0;
      for (x = 0; x < y; x++) selectedObjectTypes.push(result.jsonData.objectTypeRestrictions[x])
      this.setState({selectedObjectTypes: selectedObjectTypes});
    }
    else
      this.setState({selectedObjectTypes: []});
  }

  newButtonHandler()
  {
    this.setState({selectedObjectTypes: [], modalIsOpen: true, modalAction: 'create'});
  }

  refreshButtonHandler()
  {
    let selectedKeywordGroup = undefined;
    if (null !== this.state.selected) selectedKeywordGroup = this.state.keywordGroups[this.state.selected];
    this.fetchKeywordGroups(selectedKeywordGroup);
  }

  render()
  {
    const columns = 
    [
      {Header: 'Keyword Group ID', accessor: 'keywordGroupId', show: false},
      {Header: 'Keyword Group', accessor: 'keywordGroup'},
      {Header: 'Description', accessor: 'description'},
      {Header: 'Object Type Restrictions', accessor: 'objectTypeRestrictions', show: false}
    ]

    let keywordGroupModal = null;
    let keywordGroup = 'create' === this.state.modalAction ? undefined : this.state.keywordGroups[this.state.selected];

    if (this.state.modalIsOpen)
      keywordGroupModal = (
        <KeywordGroupModal closeModal={this.closeModal} modalAction={this.state.modalAction} modalIsOpen={this.state.modalIsOpen}
          objectTypes={this.state.objectTypes} selectedObjectTypes={this.state.selectedObjectTypes} fetchKeywordGroups={this.fetchKeywordGroups}
          keywordGroup={keywordGroup} setSelectedObjectTypes={this.setSelectedObjectTypes}
        />
      );

    return(
      <div>
        {keywordGroupModal}
        <Row style={{paddingTop: "10px"}}>
          <Col sm="4">
            <Row><Col><b>Keyword Groups - Select one to see the associated keywords.</b></Col></Row>
            <Row><Col>
              <ButtonToolbar>
                <ButtonGroup>
                  <Button onClick={this.newButtonHandler}>New</Button>
                  <Button onClick={this.editButtonHandler}>Edit</Button>
                  <Button onClick={this.deleteButtonHandler}>Delete</Button>
                  <Button onClick={this.refreshButtonHandler}>Refresh</Button>
                </ButtonGroup>
              </ButtonToolbar>
            </Col></Row>
            <Row><Col>
              <ReactTable data={this.state.keywordGroups} showPagination={false} columns={columns} minRows={1} className="-striped -highlight" 
                noDataText="No groups found"
                getTrProps={(state, rowInfo) => 
                {
                  return {
                    onClick: (e) => 
                    {
                      this.setState(
                      { 
                        selected: rowInfo.index
                      });
                    },
                    style: 
                    {
                      background: typeof rowInfo !== 'undefined' && rowInfo.index === this.state.selected ? '#00afec' : 'white',
                      color: typeof rowInfo !== 'undefined' && rowInfo.index === this.state.selected ? 'white' : 'black'
                    }
                  }
                }}
              />
            </Col></Row>
          </Col>
          <Col>
            <Row><Col><b>Associated Keywords - Select a keyword group on the left to see the associated keywords.</b></Col></Row>
            <Row><Col>
              <KeywordsInAGroup keywordGroup={keywordGroup} keywordValueTypes={this.state.keywordValueTypes} />
            </Col></Row>
          </Col>
        </Row>
        <ConfirmationModal modalIsOpen={this.state.confirmationModalIsOpen} closeModal={this.deleteKeywordGroup}
          modalText={this.state.modalText}
        />
      </div>
    );
  }

  setSelectedObjectTypes(selectedObjectTypes)
  {
    this.setState({selectedObjectTypes: selectedObjectTypes});
  }
}

KeywordGroups.contextType = AppContext;

export default KeywordGroups;